import { ICurrencyConfig } from "@/config/currency.config";
import eurIcon from "@/icons/currency/eur.svg";
import usdIcon from "@/icons/currency/usd.svg";

// Georgia-specific currency configuration
const georgiaCurrencyConfig: ICurrencyConfig = {
  currencies: [
    { label: "USD", value: "USD", icon: usdIcon, symbol: "$" },
    { label: "EUR", value: "EUR", icon: eurIcon, symbol: "€" },
  ],
  defaultCurrency: "USD",
};

export default georgiaCurrencyConfig;
